/**
 * "Last used" login-method chip — provider-agnostic, near-verbatim ES-module
 * port of the TC Visuals reference (_reference/TC Visuals/src/assets/js/
 * login-last-used.js).
 *
 * A method ('password' | 'google' | 'passkey') is recorded per DEVICE at each
 * success site (auth-screen.js succeed(), auth-modal.js form/Google/passkey
 * successes). applyLastUsedBadge() marks the wrapper whose `data-login-method`
 * matches the stored method with a small "Last used" pill.
 *
 * The badge is appended to the WRAPPER carrying data-login-method, never
 * inside the button — the auth flows swap button text/innerHTML during their
 * loading states, which would delete a child badge. Wrappers are stable.
 */

const LAST_USED_KEY = 'pb:last-login-method';

/** Record the method that just succeeded on this device. */
export function recordLastUsed(method) {
  try {
    localStorage.setItem(LAST_USED_KEY, String(method || ''));
  } catch {
    /* private mode / disabled storage — non-fatal */
  }
}

function readMethod() {
  try {
    return localStorage.getItem(LAST_USED_KEY) || '';
  } catch {
    return '';
  }
}

/**
 * Idempotently (re)apply the badge inside rootEl. Compares dataset values
 * directly — never builds a selector from the (user-controlled) stored value.
 * A stored method whose wrapper isn't rendered (e.g. passkey unavailable on
 * this origin) simply matches nothing.
 * @param {ParentNode} [rootEl=document]
 */
export function applyLastUsedBadge(rootEl = document) {
  rootEl.querySelectorAll('.pb-last-used-badge').forEach((badge) => badge.remove());
  const stored = readMethod();
  if (!stored) return;
  for (const wrap of rootEl.querySelectorAll('[data-login-method]')) {
    if (wrap.dataset.loginMethod === stored) {
      const badge = document.createElement('span');
      badge.className = 'pb-last-used-badge';
      badge.textContent = 'Last used';
      wrap.appendChild(badge);
      return;
    }
  }
}
